// src/atoms/auth.ts
import { atom } from 'recoil'

export interface AuthState {
  id: number | null
  account: string | null
  username: string | null
  isAdmin: number | null
  isApproved: number | null
  createdAt: string | null
  updatedAt: string | null
  deletedAt: string | null
}

export const authState = atom<AuthState>({
  key: 'authState',
  default: {
    id: null,
    account: null,
    username: null,
    isAdmin: null,
    isApproved: null,
    createdAt: null,
    updatedAt: null,
    deletedAt: null,
  }
})
